import Image from 'next/image';
import { imageSerializer } from '../../../../utils/imageSerializer';
import Mail from '../../../images/MailImage';
import Phone from '../../../images/PhoneImage';
import { formatPhoneNumber } from '../../../../utils/phoneNumberFormatter';
import LinkedinGradientImage from '../../../images/LinkedinGradientImage';
import {
  PersonBio,
  PersonContent,
  PersonImageWrapper,
  PersonName,
  PersonPosition,
  PersonSocialLink,
  PersonSocialLinks,
  PersonWrapper,
} from './person.styles';
import { HrTeamType } from '../interfaces';
import { RichText } from 'prismic-reactjs';
import { useWindowSize } from '../../../../hooks/useWindowSize';

export const Person = ({
  hr_person_image,
  hr_person_name,
  hr_person_title,
  hr_person_bio,
  hr_person_mail,
  hr_person_phone,
  hr_person_linkedin,
}: HrTeamType) => {
  const { medium } = useWindowSize();
  return (
    <PersonWrapper>
      <PersonImageWrapper>
        <Image {...imageSerializer(hr_person_image)} />
      </PersonImageWrapper>
      <PersonContent>
        <PersonName>{RichText.asText(hr_person_name)}</PersonName>
        <PersonPosition>{RichText.asText(hr_person_title)}</PersonPosition>
        <PersonBio>{RichText.asText(hr_person_bio)}</PersonBio>
        <PersonSocialLinks>
          <PersonSocialLink href={`mailto:${RichText.asText(hr_person_mail)}`}>
            {medium && <Mail />}
            {RichText.asText(hr_person_mail)}
          </PersonSocialLink>
          <PersonSocialLink href={`tel:${RichText.asText(hr_person_phone)}`}>
            {medium && <Phone />}
            {formatPhoneNumber(RichText.asText(hr_person_phone))}
          </PersonSocialLink>
          <PersonSocialLink
            href={RichText.asText(hr_person_linkedin)}
            target="_blank"
          >
            {medium && <LinkedinGradientImage />}
            {RichText.asText(hr_person_name)}
          </PersonSocialLink>
        </PersonSocialLinks>
      </PersonContent>
    </PersonWrapper>
  );
};
